let sidingTypeCode = trimCode = floorCode = sidingCode = eavesCode = doorCode = ''; 
const qString = window.location.search;
const uParams = new URLSearchParams(qString);
const floorParam = uParams.get('Flooring');
const sidingParam = uParams.get('Siding Color');
const eavesParam = uParams.get('Eaves Color');
const doorParam = uParams.get('Door Color');
const floorIndex = getIndexFromSelector('#ColorSelector-floor', floorParam);
const sidingIndex = getIndexFromSelector('#ColorSelector-siding', sidingParam);
const eavesIndex = getIndexFromSelector('#ColorSelector-eaves', eavesParam);
const doorIndex = getIndexFromSelector('#ColorSelector-door', doorParam);

let sidingTypeIndex = 0;
let trimIndex = 0;
let doorLocIndex = 0;
let configuratorLoaded = false;
  
$(document).on('click', 'label svg.eye-viewer', function(e){
  e.preventDefault();
  togglePopup($(this).parent().parent().find('.popup .popuptext'));
});
$('.btn-close-popup').on('click', function() {  
  $(this).parent().removeClass('show');
});

function updateModelSetting(settingType, selectedOption) { 
  if (configuratorLoaded) {
    updateModel(settingType, selectedOption.value.toLowerCase().replace(/ /g,"-"));  
    goToConfigSlide();
  }
}

function updateModel(settingType, optionValue) {
  if (optionValue === 'anodized-aluminum') {
    optionValue = 'aluminum';
  }
  if (optionValue === 'bronze-aluminum') {
    optionValue = 'studio-shed-bronze';
  }
  if (optionValue === 'paper-white') {
    optionValue = 'arctic-white';
  }
  
  switch (settingType) {
    case 'siding':
      // console.log(`calling setSiding with value ${optionValue}`);
      Harp.setSiding(optionValue);
      break;
    case 'trim':
      // console.log(`calling setTrimColor with value ${optionValue}`);
      Harp.setTrimColor(optionValue);
      break;
    case 'floor':
      // console.log(`calling setFlooring with value ${optionValue}`);
      Harp.setFlooring(optionValue);
      break;
    case 'sidingColor':
      // console.log(`calling setSidingColor with value ${optionValue}`);
      Harp.setSidingColor(optionValue);      
      break;
    case 'eaves':
      // console.log(`calling setEavesColor with value ${optionValue}`);
      Harp.setEavesColor(optionValue);      
      break;
    case 'door':
      // console.log(`calling setDoorColor with value ${optionValue}`);
      Harp.setDoorColor(optionValue);      
      break;
    case 'doorLoc':
      // console.log(`door location changed: value ${optionValue}`);
      // console.log(optionValue);
      if (optionValue === 'right') {
        Harp.loadDefaultRecipe('pagoda-right-10x12');
      }
      else {
        Harp.loadDefaultRecipe('pagoda-left-10x12');
      }
      //manually trigger flooring refresh
      triggerFlooringRefresh();
      break;
  }
}
function triggerFlooringRefresh() {
  setTimeout( () => {
    updateModel('floor', $('#ColorSelector-floor .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  }, 1000);
}
$('.variant-input-wrap[data-index="option1"] select').ddslick({
    background: '#fff',
    onSelected: function(selectedData){
      sidingTypeIndex = selectedData.original[0].selectedIndex;
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      sidingTypeCode = selectedOption.dataset.code;
      setColorCode('sidingType', sidingTypeCode);
      selectVariantOption();
      setEyeImg(selectedData, selectedOption);    
      updateSlickImage();
      updateModelSetting('siding', selectedOption);        
    }  
});
$('.variant-input-wrap[data-index="option2"] select').ddslick({
    background: '#fff',
    onSelected: function(selectedData){
      trimIndex = selectedData.original[0].selectedIndex;
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      trimCode = selectedOption.dataset.code;
      setColorCode('trim', trimCode);
      selectVariantOption();
      setEyeImg(selectedData, selectedOption);     
      updateSlickImage();
      updateModelSetting('trim', selectedOption); 
    }  
});
$('.variant-input-wrap[data-index="option3"] select').ddslick({
    background: '#fff',
    onSelected: function(selectedData){
      doorLocIndex = selectedData.original[0].selectedIndex;
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      selectVariantOption();
      updateSlickImage(selectedOption.value);
      updateModelSetting('doorLoc', selectedOption); 
    }  
});
$('#ColorSelector-floor').ddslick({
    background: '#fff',
    onSelected: function(selectedData){
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      floorCode = selectedOption.dataset.code;
      setColorCode('floor', floorCode);
      setEyeImg(selectedData, selectedOption); 
      updateModelSetting('floor', selectedOption);    
    }  
});


$('#ColorSelector-siding').ddslick({
    defaultSelectedIndex: sidingIndex,
    background: '#fff',
    onSelected: function(selectedData){
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      sidingCode = selectedOption.dataset.code;
      setColorCode('siding', sidingCode);
      setEyeImg(selectedData, selectedOption);
      updateSlickImage();
      updateModelSetting('sidingColor', selectedOption);
    }
});


let eavesSelector = $('#ColorSelector-eaves');
if (eavesSelector.length > 0) {
  $('#ColorSelector-eaves').ddslick({
      defaultSelectedIndex: eavesIndex,
      background: '#fff',
      onSelected: function(selectedData){
        let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
        eavesCode = selectedOption.dataset.code;      
        setColorCode('eaves', eavesCode);
        setEyeImg(selectedData, selectedOption);
        updateSlickImage();
        updateModelSetting('eaves', selectedOption);
      }
  });  
}

$('#ColorSelector-door').ddslick({
    defaultSelectedIndex: doorIndex,
    background: '#fff',
    onSelected: function(selectedData){
      let selectedOption = selectedData.original[0].options[selectedData.original[0].selectedIndex];
      doorCode = selectedOption.dataset.code;
      setColorCode('door', doorCode);
      setEyeImg(selectedData, selectedOption);
      updateSlickImage();
      updateModelSetting('door', selectedOption);
    }
});

$('.variant-input-wrap[data-index="option1"] select').ddslick('select', {index: sidingTypeIndex });
$('.variant-input-wrap[data-index="option2"] select').ddslick('select', {index: trimIndex });
if ($('.variant-input-wrap[data-index="option3"] select').length > 0) {
  $('.variant-input-wrap[data-index="option3"] select').ddslick('select', {index: doorLocIndex });
}
if (eavesSelector.length > 0) {
  $('#ColorSelector-eaves').ddslick('select', {index: eavesIndex });
}
$('#ColorSelector-floor').ddslick('select', {index: floorIndex });
$('#ColorSelector-door').ddslick('select', {index: doorIndex });
$('#ColorSelector-siding').ddslick('select', {index: sidingIndex });

window.addEventListener("configurator_loaded", setModelConfigOptions);
function setModelConfigOptions() {
  configuratorLoaded = true;
  setModelCurrentSettings();
}

function setModelCurrentSettings() {
  updateModel('siding', $('.variant-input-wrap[data-index="option1"] .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  updateModel('trim', $('.variant-input-wrap[data-index="option2"] .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  
  updateModel('floor', $('#ColorSelector-floor .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  updateModel('door', $('#ColorSelector-door .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  updateModel('sidingColor', $('#ColorSelector-siding .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  if (eavesSelector.length > 0) {
    updateModel('eaves', $('#ColorSelector-eaves .dd-selected-value').val().toLowerCase().replace(/ /g,"-"));
  }

  if ($('.variant-input-wrap[data-index="option3"] .dd-selected-value').length > 0) {
    let doorLocation = $('.variant-input-wrap[data-index="option3"] .dd-selected-value').val().toLowerCase().replace(/ /g,"-");
    updateModel('doorLoc', doorLocation);
    updateSlickImage($('.variant-input-wrap[data-index="option3"] .dd-selected-value').val().replace(/ /g,"-"));
  }
  else {
    updateSlickImage();
  }
}

function goToConfigSlide() {
    let ctSlide = $('.slick-track .product__thumb-item[data-index="0"]');

    if (!ctSlide.hasClass('slick-current')) {
        $('.slick-track .product__thumb-item[data-index="0"]').trigger('click');
    }
}


function setColorCode(type, color) {
    switch (type) {
    case 'sidingType':
        sidingType = color;
        break;
    case 'trim':
        trim = color;
        break;
    case 'floor':
        floor = color;
        break;
    case 'siding':
        siding = color;
        break;
    case 'eaves':
        eaves = color;
        break;
    case 'door':
        door = color;
        break;
    }

//     console.log(getColorCode());
}
function getColorCodeObj() {
	return [{'sidingType': sidingTypeCode, 'trim': trimCode, 'floor': floorCode, 'siding': sidingCode, 'eaves': eavesCode, 'door': doorCode}];
}
function getColorCode() {
  let colorCode = `${trimCode}-${sidingTypeCode}-${sidingCode}-${doorCode}-${eavesCode}`;
  if (!eavesCode) {
    colorCode = `${trimCode}-${sidingTypeCode}-${sidingCode}-${doorCode}`;
  }
  //siding type, trim, siding color, door color, eaves color
  return colorCode;
}

function selectVariantOption() {
  let selectedText = [];
  $('.variant-input-wrap').each(function() {
    let optionText = $(this).find('.dd-selected-text').html();
    if (optionText) {
      selectedText.push($(this).find('.dd-selected-text').html());
    }
  });
  if (selectedText.length === 2) {
    $('select[name="id"] option').each(function() {
      let selectedValue = $(this).val();
      let selectText = $(this).html().split(' - ')[0].replace('\n', '').trim();
      let priceText = $(this).html().split(' - ')[1].replace('\n', '').replace('USD', '').trim();
	  let regPriceText = $(this).attr('data-reg-price');
      let compareText = selectedText[0] + ' / ' + selectedText[1];
      if (selectText == compareText) {
        $('.costco-price .money').html(priceText);
        $('.regular-price .money').html(regPriceText);        
        $('select[name="id"]').val(selectedValue);
      }
      
    });
  }
  else if (selectedText.length === 3) {
    $('select[name="id"] option').each(function() {
      let selectedValue = $(this).val();
      let selectText = $(this).html().split(' - ')[0].replace('\n', '').trim();
      let priceText = $(this).html().split(' - ')[1].replace('\n', '').replace('USD', '').trim();
	  let regPriceText = $(this).attr('data-reg-price');
      let compareText = selectedText[0] + ' / ' + selectedText[1] + ' / ' + selectedText[2];
      if (selectText == compareText) {
        $('.costco-price .money').html(priceText);
        $('.regular-price .money').html(regPriceText);        
        $('select[name="id"]').val(selectedValue);
      }
      
    });
  }
}

function setEyeImg(selectedData, selectedOption) {
  let eyeImgSrc = selectedOption.dataset.eyeImg;
//   console.log(eyeImgSrc);
  let deepParent = $(selectedData.selectedItem[0].parentNode.parentNode.parentNode.parentNode);
//   console.log(deepParent.find('.popup .popuptext img'));
  deepParent.find('.popup .popuptext img').attr('src', eyeImgSrc);
}

function togglePopup(elem) {
  $('.popup').each(function() {
    let popupText = $(this).find('.popuptext');
    if (popupText !== $(elem)) {
      popupText.removeClass('show');
    }
  });
  if ($(elem).hasClass('show')) {
    $(elem).removeClass('show');
  }
  else {
    $(elem).addClass('show');
  }
}

function updateSlickImage(doorLocation = null)
{
  let colorCode = getColorCode();
  // console.log(['colorCode', colorCode]);
  $('.slider-image-variants span').each(function() {
    let sliderImgCode = $(this)[0].dataset.code;
    let sliderImgSrc = $(this)[0].dataset.src;
    
    if (colorCode == sliderImgCode) {
      // console.log(['sliderImgCode', sliderImgCode]);
      // $('.product-slick-slider .starting-slide .product-image-main .image-wrap img').attr('src', sliderImgSrc);
      let imgArr = sliderImgSrc.replace('https:', '').split('.jpg');
      let imgText = imgArr[0];
      let imgParams = imgArr[1];
      let srcSet = `${imgText}_360x.jpg${imgParams} 360w, ${imgText}_540x.jpg${imgParams} 540w, ${imgText}_720x.jpg${imgParams} 720w, ${imgText}_900x.jpg${imgParams} 900w, ${imgText}_1080x.jpg${imgParams} 1080w`;
      // let swipeSrc = `${imgText}_1800x1800.jpg${imgParams}`;
	  // $('.product-slick-slider .starting-slide .product-image-main .image-wrap img').attr('srcset', srcSet).attr('data-srcset', srcSet).attr('data-photoswipe-src', swipeSrc).removeClass('lazyloading').addClass('lazyloaded');
      $('.product__thumb-item[data-index="0"] .image-wrap .product__thumb img').attr('srcset', srcSet).attr('data-srcset', srcSet).removeClass('lazyloading').addClass('lazyloaded');
      if (doorLocation) {
        if (doorLocation === 'Left')
          $('.product__thumb-item[data-index="0"] .image-wrap .product__thumb').addClass('img-horizontal'); 
        else
          $('.product__thumb-item[data-index="0"] .image-wrap .product__thumb').removeClass('img-horizontal'); 
      }
    }
  });  

}

function getIndexFromSelector(elem, selectValue) {
  let index = 0;
  let targetIndex = 0;
  $(elem + ' option').each(function() {
    if (this.value == selectValue) {
      targetIndex = index;
    }
    index++;                         
  });
  
  return targetIndex;
}

// $(document).ready(function() {  
//   if ($('.variant-input-wrap[data-index="option3"] .dd-selected-value').length > 0) {
//   setTimeout( () => {
//     updateSlickImage();
//   }, 700);
//   }
// });